<template>
	<div class="flex flex_column flex_1">
		<AccessRestrictedTabs class="table_tabs"
							v-model="activeTab"
							:elements="tabTypes"
							:session-key="$route.path"
		/>
		<CompanyData v-if="activeTab === tabTypes.companyData"></CompanyData>
		<PutOptionSetting v-if="activeTab === tabTypes.putOptionSetting"></PutOptionSetting>
    	<TCIActivation v-if="activeTab === tabTypes.tciActivation"/>
	</div>
</template>

<script>

import CompanyData from "@/views/user/company/CompanyData";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import PutOptionSetting from "@/views/user/company/PutOptionSetting";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import TCIActivation from "@/views/user/company/TCIActivation";

export default {
  components: {
		PutOptionSetting,
		CompanyData,
		AccessRestrictedTabs,
    	TCIActivation
  },
  data() {
	  let tabTypes = {
			companyData: {
				name: navigationTabs.admin.company.info,
				translationKey: "company.tab.companyData",
				permission: enumDef.permissions.AdminCompany
			},
		    // https://walbing-jira.atlassian.net/browse/DEV-5659
			// putOptionSetting: {
			// 	name: navigationTabs.admin.company.putOptionToS,
			// 	translationKey: "company.tab.putOptionSetting",
			// 	permission: enumDef.permissions.AdminCompany
			// },
		    // DEV-6132: Hide until we have TCI again
			// tciActivation: {
			// 	name: navigationTabs.admin.company.tciActivation,
			// 	translationKey: "company.tab.tciActivation",
			// 	permission: enumDef.permissions.AdminCompany
			// }
	  };
    return {
		tabTypes: tabTypes,
		activeTab: null,
    };
  },
};
</script>